export interface IEnvVar {
  id?: number;
  level?: string | null;
  key?: string | null;
  value?: string | null;
  orgId?: number | null;
  flowId?: number | null;
}

export const defaultValue: Readonly<IEnvVar> = {};
